let HTTP_OPTIONS = {};

export const setHttpOptions = (o: any) => {
    HTTP_OPTIONS = o;
}
export const getHttpOptions = () => {
    return HTTP_OPTIONS;
}